import React from "react";
import Avatar from '@mui/material/Avatar';

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name, measure) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      opacity: 0.5,
      width: 41,
      height: 41
    },
    children: `${name.charAt(0)}`,
  };
}

export const LetterAvatar = ({
  name,
}) => {

  return (
    <Avatar {...stringAvatar(name)} />
  );
}



